module.exports = __webpack_public_path__ + "static/media/girlWithPurpleDressAndSpiralsAroundHer.6c17133d.svg";